document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.faq__list').forEach(list => {
        const allowMultiple = list.dataset.allowMultiple === 'true';

        list.addEventListener('click', e => {
            const btn = e.target.closest('.faq__question');
            if (!btn) return;

            const item    = btn.closest('.faq__item');
            const isOpen  = item.classList.contains('is-open');

            // Close all siblings unless multiple is allowed
            if (!allowMultiple) {
                list.querySelectorAll('.faq__item.is-open').forEach(openItem => {
                    if (openItem !== item) closeItem(openItem);
                });
            }

            isOpen ? closeItem(item) : openItem(item);
        });

        // Keyboard: arrow keys navigate between questions
        list.addEventListener('keydown', e => {
            if (!['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(e.key)) return;

            const buttons = [...list.querySelectorAll('.faq__question')];
            const current = buttons.indexOf(document.activeElement);
            if (current === -1) return;

            e.preventDefault();
            let next = current;
            if (e.key === 'ArrowDown') next = Math.min(current + 1, buttons.length - 1);
            if (e.key === 'ArrowUp')   next = Math.max(current - 1, 0);
            if (e.key === 'Home')      next = 0;
            if (e.key === 'End')       next = buttons.length - 1;

            buttons[next].focus();
        });
    });

    function openItem(item) {
        item.classList.add('is-open');
        item.querySelector('.faq__question').setAttribute('aria-expanded', 'true');
    }

    function closeItem(item) {
        item.classList.remove('is-open');
        item.querySelector('.faq__question').setAttribute('aria-expanded', 'false');
    }
});
